export default __webpack_public_path__ + "static/media/mittistockholm.3ec7f060.jpg";